/**
 * Explain why query controls are locked for non-granted users.
 *
 * Workday, ServiceNow, and Kuali feeds run on shared integration credentials
 * that can read far more remote data than one workspace should see. Query
 * edits therefore require an organization-level provider grant, and
 * every locked control points here so a workspace admin learns why it is
 * locked and who can unlock it, instead of hitting an unexplained 403.
 */
import { ShieldCheck } from 'lucide-react'

export function ConnectorQueryLockNotice({
  providerLabel,
  className = '',
}: {
  providerLabel: string
  className?: string
}) {
  return (
    <div
      data-testid="connector-query-lock-notice"
      className={`flex gap-2.5 rounded-lg border border-amber-200 bg-amber-50 px-3.5 py-2.5 text-xs leading-5 text-amber-800 ${className}`}
    >
      <ShieldCheck className="mt-0.5 size-3.5 shrink-0" />
      <p>
        <strong className="font-semibold">
          {providerLabel} connector administrator required.
        </strong>{' '}
        This connector&apos;s integration user can read the full underlying
        {' '}{providerLabel} data, so its query and filters are locked to keep
        this workspace scoped to its own records. An organization
        administrator can grant connector admin under User Management →
        Org Users.
      </p>
    </div>
  )
}
